import React, { useCallback, MouseEvent, ReactNode } from 'react'
import { useSpring } from 'react-spring'

import { LinkInternal } from '../../design-system'

interface ScrollLinkProps {
  path: string
  id: string
  children: ReactNode
}

export const ScrollLink = ({ path, id, children }: ScrollLinkProps) => {
  const [, setY] = useSpring(() => ({ y: 0 }))

  const handleClick = useCallback(
    (event: MouseEvent<{}>) => {
      const el = document.getElementById(id)
      const scroller = document.querySelector('#___gatsby > *')

      if (el && scroller && window.location.pathname === path) {
        event.preventDefault()
        const next = {
          y: el.getBoundingClientRect().top,
          reset: true,
          from: { y: scroller.scrollTop },
          onFrame: props => scroller.scroll(0, props.y),
          onRest: () => {
            window.location.hash = id
          },
        }

        setY(next)
      }
    },
    [setY],
  )

  return (
    <LinkInternal onClick={handleClick} to={path + '#' + id}>
      {children}
    </LinkInternal>
  )
}
